/* Lovable Blog / Journal — Wissen / Rezepte tab toggle */
(function () {
  function init(root) {
    if (!root || root.__lvbInit) return;
    root.__lvbInit = true;
    var tabs = [].slice.call(root.querySelectorAll("[data-tab]"));
    if (!tabs.length) return;
    var panels = {};
    root.querySelectorAll("[data-tab-panel]").forEach(function (p) { panels[p.getAttribute("data-tab-panel")] = p; });
    tabs.forEach(function (t) {
      t.addEventListener("click", function () {
        var key = t.getAttribute("data-tab");
        tabs.forEach(function (x) {
          var on = x === t;
          x.classList.toggle("is-on", on);
          x.setAttribute("aria-selected", on ? "true" : "false");
        });
        Object.keys(panels).forEach(function (k) { panels[k].hidden = (k !== key); });
      });
    });
  }
  function boot() { document.querySelectorAll(".lvb").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector ? e.target.querySelector(".lvb") : null;
    if (el) init(el);
  });
})();
